__turbopack_context__.v({
  "caption": "styles-module__drCGtG__caption",
  "claim": "styles-module__drCGtG__claim",
  "claimBody": "styles-module__drCGtG__claimBody",
  "claimTitle": "styles-module__drCGtG__claimTitle",
  "claims": "styles-module__drCGtG__claims",
  "ctaRow": "styles-module__drCGtG__ctaRow",
  "overlay": "styles-module__drCGtG__overlay",
  "photo": "styles-module__drCGtG__photo",
  "primaryCta": "styles-module__drCGtG__primaryCta",
  "section": "styles-module__drCGtG__section",
  "subhead": "styles-module__drCGtG__subhead",
  "title": "styles-module__drCGtG__title",
});
